import { Box, Stack, Typography, useTheme } from '@mui/material';

import { Dimens } from '~themes';

interface Props {
	steps: string[];
	currentStep: number;
}

const Stepper = ({ steps, currentStep }: Props) => {
	const { palette } = useTheme();

	return (
		<Stack direction='row' sx={{ width: '100%' }} gap={Dimens.spacingLg}>
			{steps.map((step, index) => (
				<Stack key={step} direction='column' sx={{ flex: 1 }} gap={Dimens.spacingMd}>
					<Stack direction='row' gap={Dimens.spacingMd} alignItems='center'>
						<Box
							sx={{
								display: 'flex',
								height: Dimens.spacing3xl,
								width: Dimens.spacing3xl,
								borderRadius: Dimens.radiusFull,
								justifyContent: 'center',
								alignItems: 'center',
								border: `1px solid ${palette.utilityGray50.main}`,
								boxShadow: `0px 1px 3.3px 0px rgba(0, 0, 0, 0.18)`,
							}}
						>
							<Typography variant='labelSm' color={palette.textDisabled.main}>
								{index + 1}
							</Typography>
						</Box>
						<Typography variant='labelSm' color={palette.textDisabled.main}>
							{step}
						</Typography>
					</Stack>
					<Box
						sx={{
							transition: 'background 200ms ease',
							borderRadius: Dimens.radiusXs,
							background:
								currentStep >= index ? palette.fgBrandSecondary.main : palette.bgDisabled.main,
							height: Dimens.spacingLg,
						}}
					></Box>
				</Stack>
			))}
		</Stack>
	);
};

export default Stepper;
